export default __webpack_public_path__ + "static/media/japandi-desktop.63156aee.jpg";